import React from 'react'
import AvatarImage from './../avatarImage'
import {GlobalInput} from './../Generic'

const Comments = () => {
  
  return (
    <div>
      <div className='mt-[40px]  ml-[40px]'>
        <div className='flex gap-[15px]'>
          <AvatarImage style={`w-[40px] h-[40px]`}/>
          <div className='text-[17px] font-medium'>username:</div>
        </div>
        <div className='text-[15px] ml-[55px] mr-[50px] sm:w-[500px] font-[300]'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, vitaeLorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, vitae.</div>
        <div className='relative mr-[50px] sm:mr-[100px] ml-[20px]'><GlobalInput style={`text-[black] font-[300]`}/> <div className='absolute right-0 text-[15px] bg-[white] text-gray-lightlyGray bottom-[7px]'>Replay</div></div>
      </div>
    </div>
  )
}

export default Comments